
import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/module'

import FooterBlock from '@/components/FooterBlock.vue'
import ContactBlock from '@/components/ContactBlock.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'

@Component({
  components: {
    FooterBlock,
    ContactBlock,
    Breadcrumb,
  },
})
export default class PrivacyPolicy extends Vue {
  breadcrumbItems = [
    { label: '首頁', to: '/' },
    { label: '私隱政策' },
  ]

  get isH5() {
    return AppModule.isH5
  }
}
